import React from 'react';
import { Box, Container, Typography } from '@mui/material';

const OnboardSection = () => {
  return (
    <Box
      component="section"
      className="onboard-section"
      sx={{
        py: 6,
        backgroundColor: '#F3EAE0',
      }}
    >
      <Container maxWidth="md" sx={{ textAlign: 'center' }}>
        <Typography
          variant="h4"
          gutterBottom
          className="section-heading onboard-title"
        >
          On Board Your Business Operation With Us
        </Typography>

        <Typography
          variant="subtitle1"
          className="section-text onboard-subtitle"
          sx={{
            maxWidth: 800,
            margin: '0 auto',
            color: 'var(--text-color)',
          }}
        >
          Streamline your business operations with our expert legal guidance,
          ensuring compliance, efficiency, and long-term success.
        </Typography>

        <Typography
          variant="body1"
          className="section-text onboard-text"
          sx={{
            maxWidth: 900,
            margin: '15px auto 0',
            color: 'var(--text-color)',
          }}
        >
          Partner with us to seamlessly onboard and optimize your business
          operations with expert legal guidance. From entity formation and
          regulatory compliance to contracts and risk management, we provide
          tailored solutions to ensure your business runs smoothly and legally.
          Our experienced legal team is committed to protecting your interests,
          minimizing liabilities, and fostering long-term growth. Let us handle
          the complexities so you can focus on what matters most—building a
          successful and thriving business.
        </Typography>
      </Container>
    </Box>
  );
};

export default OnboardSection;
